import type { ModuleMeta } from './types';
import { meta as dashboard } from './dashboard/meta';
import { meta as settings } from './settings/meta';
import { meta as projects } from './projects/meta';
import { meta as users } from './users/meta';
import { meta as memory } from './memory/meta';
import { meta as chat } from './chat/meta';

import { meta as guides } from './guides/meta';

export const MODULES: ModuleMeta[] = [dashboard, settings, projects, users, memory, chat, guides];

/**
 * Product navigation is intentionally smaller than the module registry. Modules keep their
 * independent routes (and remain discoverable in the command palette), while the shell presents
 * a few stable user-facing worlds. This keeps route compatibility separate from information
 * architecture, so regrouping the UI never requires redirects or aliases.
 *
 * Plugin pages are not listed here: they arrive at runtime from the /plugins/ui listing
 * (`lib/pluginNav.ts`), so a world exists exactly while the plugin that owns it is enabled.
 */
type NavigationWorldId = 'home' | 'chat' | 'projects' | 'memory' | 'guides';

export interface NavigationWorld {
  id: NavigationWorldId;
  route: string;
  icon: ModuleMeta['icon'];
  children: readonly ModuleMeta[];
}

export const NAVIGATION_WORLDS: readonly NavigationWorld[] = [
  { id: 'home', route: dashboard.route, icon: dashboard.icon, children: [] },
  { id: 'chat', route: chat.route, icon: chat.icon, children: [] },
  { id: 'projects', route: projects.route, icon: projects.icon, children: [projects] },
  { id: 'memory', route: memory.route, icon: memory.icon, children: [] },
  { id: 'guides', route: guides.route, icon: guides.icon, children: [] },
] as const;

export const SYSTEM_MODULES: readonly ModuleMeta[] = [settings, users] as const;
